import * as React from 'react';
import { observer, inject } from 'mobx-react';
import LoggedinUser from '../../models/LoggedinUser';
import { Tab, Tabs, AppBar, Toolbar } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/List';
import Tooltip from '@material-ui/core/Tooltip';
import Paper from '@material-ui/core/Drawer';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { MuiThemeProvider, createMuiTheme, Theme } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import Person from '@material-ui/icons/Person';
import { getNoBrand } from '../../index';
// import Settings from '@material-ui/icons/Settings';
// import PowerSettingsNew from '@material-ui/icons/PowerSettingsNew';
// import ListItemIcon from '@material-ui/icons/List';

//css
const tabsbarStyle = require('./tabsbar.css');


// Props
interface Props {
    loggedinUser: typeof LoggedinUser.Type;
}

//State
interface State {
    left?: boolean;
    anchorEl?: HTMLElement;
}

@observer
export default class TabsBar extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {
    state = {
        left: false,
        anchorEl: undefined,
    };

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    }

    handleClose = () => {
        this.setState({ anchorEl: null });
    }

    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open,
        });
    }


    onLogOutSel = (e) => this.props.loggedinUser.logout();

    onClickLogOut = (e) => { this.props.loggedinUser.logout(); this.handleClose(); };


    render() {

        //the background color of the drawer
        let theme: Theme = createMuiTheme();
        theme.palette.background.paper = '#0D0023';  //'#261C42'
        theme.spacing.unit = 8;


        //icons to the right in the menu
        const iconStyle = {
            marginTop: 10,
            color: '#FFFFFF'
        };

        // images
        //const branding = 'tellit';
        const noBrand = getNoBrand();
        const branding = noBrand ? ('nobrand') : (this.props.loggedinUser.branding.brandingName);
        const imgLogo = require('../../images/branding/' + branding + '/logo32x32.png');

        //const anchorEl: HTMLElement | null = this.state.anchorEl;

        const sideList = (
            <div className="drawer_list">
                <List>
                    <ListItem className="logoAndTitle">
                        <span><img src={imgLogo} alt="Mina sidor" title="Mina sidor" className="footer_logo" /></span><span className="drawer_header">{noBrand ? ('Val') : (this.props.loggedinUser.branding.displayName)}</span>
                    </ListItem>
                    <ListItem
                        onClick={e => {
                            e.preventDefault();
                            this.props.loggedinUser.view.openHomePage();
                            return false;
                        }}
                    >Översikt
                    </ListItem>
                    <ListItem
                        onClick={e => {
                            e.preventDefault();
                            this.props.loggedinUser.view.openSubscriptionsPage();
                            return false;
                        }}
                    >Abonnemang
                    </ListItem>
                    <ListItem
                        onClick={e => {
                            e.preventDefault();
                            this.props.loggedinUser.view.openBalancesPage();
                            return false;
                        }}
                    >Saldo
                    </ListItem>
                </List>
            </div>
        );

        return (
            <div>

                <div className="tabsbar_root">
                    <AppBar position="static" style={{ backgroundColor: '#0D0023' }}>
                        <Toolbar>
                            {/* <Button
                                className="tabsbar_menuButton"
                                color="inherit"
                                aria-label="Menu"
                                style={{ visibility: (this.props.loggedinUser.isauthenticated && this.props.loggedinUser.subscriptions.items.length != 0) ? 'visible' : 'hidden' }}
                                > */}
                            <MenuIcon onClick={this.toggleDrawer('left', true)}
                                style={{ visibility: (this.props.loggedinUser.isauthenticated && this.props.loggedinUser.subscriptions.items.length !== 0) ? 'visible' : 'hidden' }}
                                aria-label="Menu"
                                color="inherit"
                                className="tabsbar_menuButton"
                            />
                            {/* </Button> */}
                            <Typography variant="title" color="inherit" className="tabsbar_flex">
                                Mina sidor
                        </Typography>
                            {/* <Settings style={{visibility: "hidden"}} /> */}
                            {/* <PowerSettingsNew style={{visibility: "hidden"}} onClick={this.onLogOutSel}/> */}
                            <IconButton color="inherit" aria-haspopup="true" onClick={this.handleClick}>

                                <Person style={{ visibility: this.props.loggedinUser.isauthenticated ? 'visible' : 'hidden' }} className="personIcon" />

                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={this.handleClose}
                                style={{ visibility: this.props.loggedinUser.isauthenticated && this.props.loggedinUser.view.showMenuUserIcon ? 'visible' : 'hidden' }}
                            >
                                <MenuItem style={{ color: 'white', fontStyle: 'italic', fontSize: 12 }} >Inloggad som {this.props.loggedinUser.firstName}</MenuItem>
                                <MenuItem onClick={this.onClickLogOut} style={{ color: 'white', fontWeight: 'bold', fontSize: 12 }}>Logga ut</MenuItem>
                            </Menu>
                        </Toolbar>
                    </AppBar>
                </div>
                <MuiThemeProvider theme={theme}>
                    <Drawer open={this.state.left} onClose={this.toggleDrawer('left', false)} style={{ color: 'white' }}>
                        <div
                            tabIndex={0}
                            role="button"
                            onClick={this.toggleDrawer('left', false)}
                            onKeyDown={this.toggleDrawer('left', false)}
                        >
                            {sideList}
                        </div>
                    </Drawer>
                </MuiThemeProvider>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tabsbar/TabsBar.tsx